module.exports = __webpack_public_path__ + "static/media/jonathan-olmon.9dca9c5c.jpg";